export default {
  ON_BOARDING_EMAIL_REPOSITORY: Symbol.for('ON_BOARDING_EMAIL_REPOSITORY'),
  ON_BOARDING_VERIFY_EMAIL_EXISTENCE_QUERY:
    Symbol.for('ON_BOARDING_VERIFY_EMAIL_EXISTENCE_QUERY'),
};
